import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["open", "onToggle"]
const _hoisted_3 = { class: "d-inline fs-6" }
const _hoisted_4 = ["innerHTML"]

import { computed, onMounted, onUnmounted, ref } from 'vue';
import { BAlert, BButton, BModal } from 'bootstrap-vue-next';
import { useApolloClient } from '@vue/apollo-composable';
import { ComputeTasksDocument, ComputeTaskType } from '@/gql/graphql';
import { useUserStore } from '@/store/user';
import { computeTaskDebugSections } from '@/utils/compute-task-debug-sections';
import { highlightJson } from '@/utils/prism-utils';


export default /*@__PURE__*/_defineComponent({
  __name: 'ComputeTaskDebugDetails',
  props: {
    taskId: {},
    projectId: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const { resolveClient } = useApolloClient();
const userStore = useUserStore();
const task = ref<ComputeTaskType | null>(null);
const debugError = ref(false);
const trigger = document.activeElement;
onUnmounted(() => {
  if (trigger instanceof HTMLElement && trigger.isConnected) trigger.focus();
});
const sections = computed(() => computeTaskDebugSections(task.value || {}));
const raw = ref(false);
const openSections = ref(new Set<string>());
onMounted(loadTask);
async function loadTask() {
  debugError.value = false;
  try {
    const { data } = await resolveClient().query({
      query: ComputeTasksDocument,
      variables: {
        id: props.taskId,
        projectId: props.projectId,
        acrossUsers: userStore.admin,
        pagingItemsPerPage: 1,
      },
      fetchPolicy: 'no-cache',
    });
    task.value = data.computeTasks?.computeTasks?.[0] || null;
    debugError.value = !task.value;
  } catch {
    debugError.value = true;
  }
}
function toggleSection(id: string, event: Event) {
  if ((event.target as HTMLDetailsElement).open) openSections.value.add(id);
  else openSections.value.delete(id);
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (debugError.value)
      ? (_openBlock(), _createBlock(_unref(BAlert), {
          key: 0,
          "model-value": true,
          variant: "danger"
        }, {
          default: _withCtx(() => [
            _cache[4] || (_cache[4] = _createTextVNode(" Could not load debug details. Please try again. ", -1)),
            _createVNode(_unref(BButton), {
              size: "sm",
              variant: "outline-danger",
              onClick: loadTask
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode("Retry", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (task.value)
      ? (_openBlock(), _createBlock(_unref(BModal), {
          key: 1,
          "model-value": true,
          size: "xl",
          scrollable: "",
          onHidden: _cache[2] || (_cache[2] = ($event: any) => (emit('close')))
        }, {
          header: _withCtx(() => [
            _createElementVNode("h2", null, [
              _createVNode(_component_font_awesome_icon, {
                icon: "code",
                class: "me-2"
              }),
              _createTextVNode(_toDisplayString(task.value.name) + " (" + _toDisplayString(task.value.id) + ") ", 1)
            ])
          ]),
          footer: _withCtx(() => [
            _createVNode(_unref(BButton), {
              variant: "secondary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
            }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createTextVNode("Close", -1)
              ]))]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(BButton), {
              class: "mb-3",
              size: "sm",
              variant: "outline-secondary",
              "aria-pressed": raw.value,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (raw.value = !raw.value))
            }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createTextVNode("Raw JSON", -1)
              ]))]),
              _: 1
            }, 8, ["aria-pressed"]),
            (raw.value)
              ? (_openBlock(), _createElementBlock("pre", {
                  key: 0,
                  class: "code-highlight",
                  innerHTML: _unref(highlightJson)(task.value)
                }, null, 8, _hoisted_1))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(sections.value, (section) => {
                  return (_openBlock(), _createElementBlock("details", {
                    key: section.id,
                    open: openSections.value.has(section.id),
                    class: "mb-3",
                    onToggle: ($event: any) => (toggleSection(section.id, $event))
                  }, [
                    _createElementVNode("summary", null, [
                      _createElementVNode("h3", _hoisted_3, _toDisplayString(section.title), 1)
                    ]),
                    (openSections.value.has(section.id))
                      ? (_openBlock(), _createElementBlock("pre", {
                          key: 0,
                          class: "code-highlight",
                          innerHTML: _unref(highlightJson)(section.content)
                        }, null, 8, _hoisted_4))
                      : _createCommentVNode("", true)
                  ], 40, _hoisted_2))
                }), 128))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})